import { useEffect, useRef } from "react";

/**
 * Хук для обработки кликов вне указанного элемента
 */
export const useClickOutsideRef = (callback: () => void) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const cancelHandler = (event: MouseEvent) => {
      const target = event && (event.target as Element);
      if (ref.current && !ref.current.contains(target)) {
        callback();
      }
    };

    document.addEventListener("mousedown", cancelHandler);

    return () => document.removeEventListener("mousedown", cancelHandler);
  }, [callback]);

  return ref;
};
